import { useFela } from 'react-fela';
import { upperFirst as _upperFirst } from 'lodash';

import config from 'config/index';

import rule from './Logo.rule';

const Logo = () => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <img alt={_upperFirst(config.app.name)} src={config.app.brand.images.logo} />
        </div>
    );
};

export default Logo;
